module.exports = __webpack_public_path__ + "assets/svg/Icons/48/task-blue-f3d109.svg";